import { useDispatch, useSelector } from "react-redux";
import { ActivateViewFilterAction, DeactivateViewFilterAction } from "../../../../store/analytics/Analytics";
import { useState, useEffect } from "react";
import { ApplicationState } from "../../../../store";
import { NumericEntityFilterParameter } from "../../../../models/viz/filters/NumericEntityFilter";

export interface NumericFilterProps {
    viewId: string;
    filterId: string;
    maximum: number;
}

function NumericFilter(props: NumericFilterProps) {
    const dispatch = useDispatch();

    const filterParams = useSelector((state: ApplicationState) => {
        const filter = state.analytics.views[props.viewId]?.filters[props.filterId];
        return filter?.params as NumericEntityFilterParameter | undefined;
    });

    const isActive = useSelector((state: ApplicationState) => {
        const filter = state.analytics.views[props.viewId]?.filters[props.filterId];
        return filter?.isActive ?? false;
    });

    const [sliderValue, setSliderValue] = useState(filterParams?.minimum ?? 0);

    useEffect(() => {
        if (isActive && filterParams?.minimum !== undefined) {
            setSliderValue(filterParams.minimum);
        } else if (!isActive) {
            setSliderValue(0);
        }
    }, [filterParams, isActive]);

    function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = parseFloat(e.target.value);
        setSliderValue(value);

        if (!isNaN(value) && value > 0) {
            dispatch({
                type: "analytics/activateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId, parameter: { minimum: value } },
            } as ActivateViewFilterAction);
        } else {
            dispatch({
                type: "analytics/deactivateViewFilter",
                payload: { viewId: props.viewId, filterId: props.filterId },
            } as DeactivateViewFilterAction);
        }
    }

    return (
        <div>
            <input
                type="range"
                step={props.maximum / 20}
                max={props.maximum}
                value={sliderValue}
                onChange={handleOnChange}
            />
            <div className="numeric-value text-muted">Showing from {sliderValue.toFixed(2)}</div>
        </div>
    );
}

export default NumericFilter;
